
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ExchangeRateDialog extends Serenity.EntityDialog<ExchangeRateRow, any> {
        protected getFormKey() { return ExchangeRateForm.formKey; }
        protected getIdProperty() { return ExchangeRateRow.idProperty; }
        protected getLocalTextPrefix() { return ExchangeRateRow.localTextPrefix; }
        protected getNameProperty() { return ExchangeRateRow.nameProperty; }
        protected getService() { return ExchangeRateService.baseUrl; }
        protected getDeletePermission() { return ExchangeRateRow.deletePermission; }
        protected getInsertPermission() { return ExchangeRateRow.insertPermission; }
        protected getUpdatePermission() { return ExchangeRateRow.updatePermission; }

        protected form = new ExchangeRateForm(this.idPrefix);
        constructor() {
            super();
            q.setTextRightAlign(this.form.ExchRate);
        }
    }
}